AFRAME.registerComponent('reposition-popup', {
    init: function () {
        this._initVariables();

        if (this.el.sceneEl.hasLoaded) {
            this.onSceneLoaded();
        } else {
            this.el.sceneEl.addEventListener('loaded', this.onSceneLoaded.bind(this));
        }
    },

    _initVariables: function () {
        this.mainSettingsPopup = document.querySelector('#main-settings-popup');
        this.popupBgDark = this.el.querySelector('.background-panel-dark');
        this.popupBgLight = this.el.querySelector('.background-panel-light');
    },

    onSceneLoaded: function () {
        if (window.PopupManager) {
            window.PopupManager.register('reposition-popup', this.el);
        }
    },

    open: function () {
        this.el.setAttribute('visible', true);
        this.render();
        this._isManualClose = false;
    },

    close: function () {        
        if (!this._isManualClose) {
             const mainSettings = this.mainSettingsPopup ? this.mainSettingsPopup.components['main-settings'] : null;
             if (mainSettings) {
                 mainSettings.handleCancel();
             }
        }

        const content = this.el.querySelector('#reposition-popup-content');
        if (content) content.innerHTML = '';
        this.el.setAttribute('visible', false);
        this._isManualClose = false;
    },

    render: function () {
        const content = this.el.querySelector('#reposition-popup-content');
        if (!content) {
            const newContent = document.createElement('a-entity');
            newContent.setAttribute('id', 'reposition-popup-content');
            this.el.appendChild(newContent);
            this.render();
            return;
        }
        content.innerHTML = '';

        const mainSettings = this.mainSettingsPopup ? this.mainSettingsPopup.components['main-settings'] : null;
        if (!mainSettings) {
            console.error('RepositionPopup: main-settings component not found');
            return;
        }

        const isLight = mainSettings.data.themeMode === 'Light';
        const txtColor = isLight ? '#14141C' : '#FFFFFF';
        
        if (this.popupBgDark) this.popupBgDark.setAttribute('visible', !isLight);
        if (this.popupBgLight) this.popupBgLight.setAttribute('visible', isLight);

        const rowHeight = 0.05;
        const btnWidth = 0.15;
        const padding = 0.01;

        const togglesContainer = document.createElement('a-entity');
        togglesContainer.setAttribute('position', '0 0.05 0.01');
        content.appendChild(togglesContainer);

        const createToggle = (label, isActive, onToggle, yPos) => {
            const toggleEl = document.createElement('a-entity');
            toggleEl.setAttribute('position', `-0.22 ${yPos} 0`);
            
            const labelEl = document.createElement('a-troika-text');
            labelEl.setAttribute('value', label);
            labelEl.setAttribute('font-size', 0.02);
            labelEl.setAttribute('color', txtColor);
            labelEl.setAttribute('anchor', 'left');
            toggleEl.appendChild(labelEl);

            const toggleCircleBg = document.createElement('a-rounded-plane');
            toggleCircleBg.setAttribute('position', '0.4 -0.01 0');
            toggleCircleBg.setAttribute('color', isLight ? '#1E1E1E' : '#fff');
            toggleCircleBg.setAttribute('opacity', '0.05');
            toggleCircleBg.setAttribute('height', 0.02);
            toggleCircleBg.setAttribute('width', 0.06);
            toggleCircleBg.setAttribute('radius', 0.006);
            toggleEl.appendChild(toggleCircleBg);

            const toggleButton = document.createElement('a-rounded-plane');
            toggleButton.setAttribute('position', isActive ? '0.43 -0.015 0.005' : '0.4 -0.015 0.005');
            toggleButton.setAttribute('width', 0.03);
            toggleButton.setAttribute('height', 0.03);
            const activeColor = isLight ? '#3636E3' : '#FFF';
            const inactiveColor = isLight ? '#737373' : '#4F4F4F';
            toggleButton.setAttribute('color', isActive ? activeColor : inactiveColor);
            toggleButton.setAttribute('radius', 0.003);
            toggleEl.appendChild(toggleButton);

            const clickArea = document.createElement('a-plane');
            clickArea.setAttribute('width', 0.45);
            clickArea.setAttribute('height', 0.04);
            clickArea.setAttribute('position', '0.22 0 0.01');
            clickArea.setAttribute('opacity', '0');
            clickArea.setAttribute('data-raycastable', '');
            clickArea.addEventListener('click', onToggle);
            toggleEl.appendChild(clickArea);

            return toggleEl;
        };

        const toggleBg = createToggle('Show background panel', mainSettings.data.bgPanelsShow, () => {
            mainSettings.el.setAttribute('main-settings', 'bgPanelsShow', !mainSettings.data.bgPanelsShow);
            mainSettings.applySettings();
            this.render();
        }, 0.01);
        togglesContainer.appendChild(toggleBg);

        const toggleRotate = createToggle('Auto-rotate panels', mainSettings.data.autoRotatePanels, () => {
            mainSettings.el.setAttribute('main-settings', 'autoRotatePanels', !mainSettings.data.autoRotatePanels);
            mainSettings.applySettings();
            this.render();
        }, -0.04);
        togglesContainer.appendChild(toggleRotate);

        const title = document.createElement('a-troika-text');
        title.setAttribute('value', 'Reposition');
        title.setAttribute('font-size', 0.035);
        title.setAttribute('color', txtColor);
        title.setAttribute('anchor', 'center');
        title.setAttribute('position', '0 0.12 0.01');
        content.appendChild(title);

        const container = document.createElement('a-entity');
        container.setAttribute('position', '0 -0.06 0.01');
        content.appendChild(container);
        const totalWidth = 3 * btnWidth + 2 * padding;
        const startX = -totalWidth / 2 + btnWidth / 2;

        const closePopup = () => {
            if (window.PopupManager) {
                window.PopupManager.close('reposition-popup');
            } else {
                this.close();
            }
        };

        const btnCancel = document.createElement("a-entity");
        btnCancel.setAttribute("ui-button", {
            label: "Cancel",
            colorScheme: "primary",
            width: btnWidth,
            height: rowHeight,
            depth: 0.01,
            type: "rounded-box",
            radius: 0.01,
            preferredFontSize: 0.02,
        });
        btnCancel.setAttribute('position', `${startX} 0 0`);
        btnCancel.addEventListener('click', () => {
            this._isManualClose = true;
            mainSettings.handleCancel();
            closePopup();
        });
        container.appendChild(btnCancel);

        const btnSave = document.createElement("a-entity");
        btnSave.setAttribute("ui-button", {
            label: "Save",
            colorScheme: "cta",
            width: btnWidth,
            height: rowHeight,
            depth: 0.01,
            type: "rounded-box",
            radius: 0.01,
            preferredFontSize: 0.02,
        });
        btnSave.setAttribute('position', `${startX + btnWidth + padding} 0 0`);
        btnSave.addEventListener('click', () => {
            this._isManualClose = true;
            mainSettings.handleSave();
            closePopup();
        });
        container.appendChild(btnSave);

        const btnReset = document.createElement("a-entity");
        btnReset.setAttribute("ui-button", {
            label: "Reset",
            colorScheme: "primary",
            width: btnWidth,
            height: rowHeight,
            depth: 0.01,
            type: "rounded-box",
            radius: 0.01,
            preferredFontSize: 0.02,
        });
        btnReset.setAttribute('position', `${startX + 2 * (btnWidth + padding)} 0 0`);
        btnReset.addEventListener('click', () => {
            this._isManualClose = true;
            mainSettings.handleReset();
            closePopup();
        });
        container.appendChild(btnReset);
    }
});
